export default "__VITE_ASSET__D$duVCI0__"